import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IDistrict } from 'src/models/district.model';
import services from 'src/services/district.service';

export const actionTypes = {
  DISTRICT_LIST_FETCH: 'DISTRICT_LIST_FETCH',
  DISTRICT_ADD: 'DISTRICT_ADD',
  DISTRICT_UPDATE: 'DISTRICT_UPDATE',
  DISTRICT_DELETE: 'DISTRICT_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.DISTRICT_LIST_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.DISTRICT_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.DISTRICT_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.DISTRICT_DELETE,
    service: services.itemDELETE,
  },
};

export type IDistrictAsync = typeof asyncActions;
export interface IDistrictState extends ICommonState<IDistrictAsync> {
  data?: IDistrict;
  list: IDistrict[];
  total: number;
}

export const defaultState: IDistrictState = {
  status: {},
  list: [],
  total: 0,
};

const DistrictReducer = (
  state: IDistrictState = defaultState,
  action: IReducerAction<IDistrictAsync>
): IDistrictState => {
  switch (action.type) {
    case actionTypes.DISTRICT_LIST_FETCH: {
      return {
        ...state,
        list: action.payload?.rows ?? [],
        total: action.payload?.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default DistrictReducer;
